import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import Navbar from './pages/Navbar';
import LoginPage from './components/Auth/Login';
import DashboardPage from './pages/DashboardPage';
import ProjectPage from './pages/ProjectPage';
import ReportPage from './pages/Report';
import AnalyticsPage from './pages/AnalyticsPage';
import ProfilePage from './pages/Profile';
import AboutUsPage from './pages/about/about';
import Login from './components/Auth/Login';
import Registration from './components/Auth/Registration';
import { AuthProvider } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';
import TeamManagement from './pages/TeamManagement';
import Task from './pages/user/Task';
import CompletedTask from './pages/user/CompletedTasks';
import UpcammingTask from './pages/user/UpcommingTask';
import ProjectForm from './pages/ProjectForm';
// src/App.js
import 'leaflet/dist/leaflet.css';
import Home from './pages/Home';
import Contact from './pages/Contact';
import Report from './pages/user/MyReoports';
import Equipment from './pages/user/Equipment';
import TeamDetails from './components/supervisor/TeamDeatails';
import 'bootstrap/dist/css/bootstrap.min.css';
import MyTeams from './pages/user/MyTeam';
import { AnimatePresence } from 'framer-motion';
import ReportDetail from './components/common/ReportDetail';
import ChangePassword from './components/common/ChangePassword';


const theme = createTheme({
  palette: {
    primary: {
      main: '#2c3e50',
    },
    secondary: {
      main: '#3498db',
    },
  },
});

function App() {
  return (

    <AuthProvider>
      <NotificationProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Router>
            <Routes>
              <Route path="/*" element={
                <>
                  <Navbar />
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/dashboard" element={<DashboardPage />} />
                    <Route path="/projects" element={<ProjectPage />} />
                    <Route path="/reports" element={<ReportPage />} />
                    <Route path="/analytics" element={<AnalyticsPage />} />
                    <Route path="/profile" element={<ProfilePage />} />
                    <Route path="/about" element={<AboutUsPage />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/register" element={<Registration />} />
                    <Route path="/tasks" element={<Task />} />
                    <Route path="/my-Reports" element={<Report />} />
                    <Route path="/equipment" element={<Equipment />} />
                    <Route path="/team" element={<TeamManagement />} />
                    <Route path="/team/:teamId" element={<TeamDetails />} />
                    <Route path="/reports/:id" element={<ReportDetail />} />
                    <Route path="/my-team" element={<MyTeams />} />
                    <Route path="/projects/new" element={<ProjectForm isEdit={false} />} />
                    <Route path="/projects/edit/:id" element={<ProjectForm isEdit={true} />} />
                    <Route path="/upcoming-tasks" element={<UpcammingTask />} />
                    <Route path="/change-password" element={<ChangePassword />} />
                    <Route path="*" element={<div>404 Not Found</div>} />
                  </Routes>
                </>
              } />
            </Routes>
          </Router>
        </ThemeProvider>
      </NotificationProvider>
    </AuthProvider>
    
    
  );
}

export default App;